// extracted by mini-css-extract-plugin
export var contentBody = "_8q-9";
export var headerImage = "_8q-2";
export var imageButton = "_8q-7";
export var imageButtonIcon = "_8q-8";
export var imageHeader = "_8q-4";
export var imageHeaderText = "_8q-5";
export var imageOverlay = "_8q-3";
export var imageTitle = "_8q-6";
export var imageWrapper = "_8q-1";
export var taskList = "_8q-a";
export var widget = "_8q-0";